import 'Utils/responsiveHelper';

export default function initContactForm() {
	const hiddenClass = 'hidden-field';
	const additionalClass = 'schedule-selected';
	const additionalClass2 = 'contact-selected';

	jQuery(document).bind('gform_post_render', function() {
		contactFormInit();
	});

	function contactFormInit() {
		jQuery('.lightbox-contact').each(function() {
			const holder = jQuery(this);
			const leftCol = holder.find('.js-left-col');
			const rightCol = holder.find('.js-right-col');
			const topCol = holder.find('.js-top-full-width');
			const leftColItems = holder.find('.js-left-col-child');
			const rightColItems = holder.find('.js-right-col-child');
			const topColItems = holder.find('.js-top-full-width-col-child');
			const checkboxHolder = holder.find('.js-checkbox-holder');
			const checkboxes = holder.find('.js-checkboxes');
			const scheduleFields = holder.find('.js-schedule-field');
			const selectField = holder.find('.js-select-field');
			const scheduleSwitcher = holder.find(':checkbox[value="Schedule A Tour"]');
			const contactSwitcher = holder.find(':checkbox[value="Contact A Community"]');
			const formBody = holder.find('.g-form-custom-body');
			const logo = holder.find('.modal-logo').clone();
			const logoHolder = holder.find('.js-logo-holder');
			const linkHolder = holder.find('.js-link-holder');
			const link = holder.find('.gf-form-link');

			leftColItems.appendTo(leftCol);
			rightColItems.appendTo(rightCol);
			checkboxes.appendTo(checkboxHolder);

			const switchers = checkboxHolder.find('.gfield-choice-input');

			if (scheduleSwitcher.length) {
				if (scheduleSwitcher.is(':checked')) {
					formBody.addClass(additionalClass);
				} else {
					scheduleFields.addClass(hiddenClass);
				}
			}

			if (contactSwitcher.length) {
				if (contactSwitcher.is(':checked')) {
					formBody.addClass(additionalClass2);
				} else {
					selectField.addClass(hiddenClass);
				}
			}

			if (link.length && linkHolder.length) {
				linkHolder.empty();
				link.clone(true).appendTo(linkHolder);
			}

			if (logo.length && logoHolder.length) {
				logoHolder.empty();
				logo.appendTo(logoHolder);
			}

			jcf.replaceAll();

			ResponsiveHelper.addRange({
				'0..767': {
					on: function() {
						selectField.appendTo(leftCol);
						topColItems.appendTo(topCol);
					}
				},
				'768..1023': {
					on: function() {
						if (!scheduleSwitcher.is(':checked')) {
							selectField.insertBefore(rightCol.find('.gfield:first-child'));
						}

						topColItems.appendTo(topCol);
					}
				},
				'1024..': {
					on: function() {
						selectField.appendTo(leftCol);
						topColItems.insertBefore(rightCol.find('.gfield:first-child'));
					}
				}
			});

			switchers.on('change', function() {
				const field = jQuery(this);

				if (field.attr('value').toLowerCase() === 'schedule a tour') {
					if (field.is(':checked')) {
						scheduleFields.removeClass(hiddenClass);
						selectField.appendTo(leftCol);
						formBody.addClass(additionalClass);
					} else {
						scheduleFields.addClass(hiddenClass);
						formBody.removeClass(additionalClass);

						ResponsiveHelper.addRange({
							'0..767': {
								on: function() {
									selectField.appendTo(leftCol);
								}
							},
							'768..1023': {
								on: function() {
									selectField.insertBefore(rightCol.find('.gfield:first-child'));
								}
							},
							'1024..': {
								on: function() {
									selectField.appendTo(leftCol);
								}
							}
						});
					}
				} else if (field.attr('value').toLowerCase() === 'contact a community') {
					if (field.is(':checked')) {
						selectField.removeClass(hiddenClass);
						formBody.addClass(additionalClass2);
					} else {
						selectField.addClass(hiddenClass);
						formBody.removeClass(additionalClass2);
					}
				}
			});
		});
	}
}